<script>
import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: 'CategoryEndorsment',
  extends: Bar,
  mixins: [reactiveProp],

  props: {
    chartData: { required: true, type: Object },
    options: { required: true, type: Object },
    chartId: { default: 'endorsment-chart', type: String }
  },

  mounted () {
    this.renderThat()
  },

  methods: {
    renderThat () {
      this.renderChart(this.chartData, this.options)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/reports/charts/CategoryEndorsment.vue